<template>
  <div>
    <label v-for="(option, index) in field.values"
           class="mt-checkbox mt-checkbox-outline"
           v-show="!isValueHidden(option.label)"
    >
      {{ option.label }}
      <input :name="field.name+'-'+index"
             type="checkbox"
             :id="option.name"
             :disabled="locked"
             :value="option.label"
             :checked="value.includes(option.label)"
             :data-vv-as="field.description.replace(/\./g, '')"
             :data-vv-name="field.name"
             v-validate="{required: required && !field.hide && value.length === 0}"
             @change="toggleValue(option.label)"
      />
      <!-- XXX: this span is required for custom checkbox to display icon -->
      <span></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    hiddenValues: {
      type: Array,
      default: false,
    }
  },

  emits: ['input'],

  setup(props, { emit }) {
    // TODO: move to composable
    const isValueHidden = (value) => {
      if (props.hiddenValues) {
        return props.hiddenValues.some(h => {
          return h.field === props.field.name && value === h.value
        })
      }
      return false;
    }

    const toggleValue = (value) => {
      if (props.value.includes(value)){
        emit('input', props.value.filter(v => v !== value))
      } else {
        emit('input', [value, ...props.value])
      }
    }

    return {
      isValueHidden,
      toggleValue,
    }
  }
}
</script>

<style scoped lang="scss">
.mt-checkbox-list, .mt-radio-list {
  padding: 0;
  display: block;
}
.mt-checkbox {
  display: block;
}
</style>



// WEBPACK FOOTER //
// CheckboxGroupRender.vue?0f782f88